export default __webpack_public_path__ + "static/media/img_vision_06_1_m.d9fd19fd.png";